import React, { useState } from 'react';
import { Box, ButtonBase, makeStyles } from '@material-ui/core';
import { useDispatch, useSelector } from 'react-redux';
import _ from 'lodash';
import { classNames } from '../../../../utils';
import { LOGIN_INFO, NOTIFICATION_MESSAGE, WARD_INFO } from '../../../../comm/constant';
import { updateLoginInfoAction, updateWardinfoAction } from '../../../../redux/actions';
import { i18n } from '../../../../language';
import setting_reset from '../../../../static/images/setting_reset.png';
import { authNameE } from '../../../../utils/userFuncs';
import { mutationUpdateOtherLoginInfo } from '../../../../utils/handleUpdateOtherLoginInfo';
import ReastPop from './ReastPop';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    margin: '1.813rem 3.438rem 1.25rem 3.438rem',
  },
  tabBox: {
    display: 'flex',
    flexWrap: 'wrap',
    gridRowGap: '0.5rem',
    '& > button:nth-child(n+2)': {
      marginLeft: '0.625rem',
    },
  },
  button: {
    width: '10rem',
    height: '3.875rem',
    backgroundColor: '#538fff11',
    borderRadius: '0.75rem 0.75rem 0 0',
    fontFamily: 'NotoSans-Bold',
    fontSize: '1rem',
    fontWeight: '600',
    color: '#538fff88',
  },
  select: {
    backgroundColor: '#fff',
    fontWeight: 'bold',
    background: '#fff',
    color: '#538fff',
  },
  content: {
    height: '100%',
    background: '#fff',
    borderRadius: '0 0.937rem 0.937rem 0.937rem',
    overflow: 'auto',
    display: 'flex',
    flexDirection: 'column',
  },
  addBtn: {
    fontFamily: 'NotoSans-Medium',
    fontSize: '1rem',
    fontWeight: '500',
    color: '#7d86a9',
    marginRight: '1.875rem',
  },
  resetImg: {
    width: '1.5rem',
    height: '1.5rem',
    marginRight: '0.938rem',
  },
}));

// itemList => id, isSelect, text, Component
export default function TabBar({ className, onClick, lists, index }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const language = useSelector((state) => state.settings.language);

  const tabTexts = {
    [authNameE.setting_view_Hospital]: i18n.t('SETTING_HOSPITAL'),
    [authNameE.setting_view_ward]: i18n.t('SETTING_WARD'),
    [authNameE.setting_view_role]: i18n.t('SETTING_ROLE'),
    [authNameE.setting_view_user]: i18n.t('SETTING_USER'),
    [authNameE.setting_view_equipment]: i18n.t('SETTING_EQUIPMENT'),
    [authNameE.setting_view_databaseMapping]: i18n.t('SETTING_MAPPING'),
    [authNameE.setting_view_TeleVisit]: i18n.t('SETTING_TELEVISIT'),
    [authNameE.setting_view_Hospital_Tag]: i18n.t('SETTING_HOSPITAL_TAG'),
    [authNameE.setting_view_Ward_Tag]: i18n.t('SETTING_WARD_TAG'),
    [authNameE.setting_view_admission]: 'Admission',
    [authNameE.setting_view_bedstatus]: 'BedStatus',
    [authNameE.setting_view_Ward_ChatCategory]: i18n.t('DUTYASSIGN_ROSTER_SETTING_CC_SETTING_TITLE'),
  };

  const contentCtr = () => {
    if (Array.isArray(lists) && lists.length > 0 && index > -1) {
      const Component = _.find(lists, (item) => {
        return item.id === index;
      })?.Component ?? <div />;
      return <Component language={language} />;
    }
  };

  const tabBtnCtr = () => {
    if (Array.isArray(lists) && lists.length > 0 && index > -1) {
      return lists.map((item) => {
        const claN = index === item.id ? classNames(classes.button, classes.select) : classes.button;
        return (
          <ButtonBase
            className={claN}
            key={item.id}
            onClick={() => {
              if (typeof onClick === 'function') {
                return onClick(item.id);
              }
            }}
          >
            {tabTexts[item.id] || ''}
          </ButtonBase>
        );
      });
    }
  };

  const resetHandle = () => {
    localStorage.removeItem(WARD_INFO);
    localStorage.removeItem(LOGIN_INFO);
    mutationUpdateOtherLoginInfo();
    localStorage.removeItem(NOTIFICATION_MESSAGE);
    dispatch(updateWardinfoAction(false, '', '', null, null));
    dispatch(updateLoginInfoAction({ flag: false }));
  };

  const [isResetPop, setIsReastPop] = useState(false);
  const closeResetPop = () => {
    setIsReastPop(false);
  };
  const showResetPop = () => {
    setIsReastPop(true);
  };

  return (
    <>
      {isResetPop ? <ReastPop open={isResetPop} closePop={closeResetPop} confirmClick={resetHandle} /> : ''}
      <div className={classNames(classes.root, className)}>
        <Box display="flex" justifyContent="space-between" alignItems="center">
          <div className={classes.tabBox}>{tabBtnCtr()}</div>

          <ButtonBase id="setting_reset_ward_btn" className={classes.addBtn} onClick={showResetPop}>
            <img alt="" src={setting_reset} className={classes.resetImg} />
            {i18n.t('SETTING_RESET_WARD')}
          </ButtonBase>
        </Box>
        <div className={classes.content} id="tab-content">
          {contentCtr()}
        </div>
      </div>
    </>
  );
}
